import { useState } from 'react';

interface EpisodeListProps {
  episodeCount: number;
  showTitle: string;
}

const buildNote = (showTitle: string, episode: number) =>
  `第 ${episode} 集围绕《${showTitle}》的核心线索展开，人物关系进一步推进，为后续剧情埋下关键伏笔。（演示说明，本站不提供在线播放）`;

export default function EpisodeList({ episodeCount, showTitle }: EpisodeListProps) {
  const [expanded, setExpanded] = useState<number | null>(1);
  const [showAll, setShowAll] = useState(false);

  const episodes = Array.from({ length: episodeCount }, (_, index) => index + 1);
  const visibleEpisodes = showAll ? episodes : episodes.slice(0, 12);

  return (
    <div>
      <div className="rounded-lg border border-background-200 overflow-hidden divide-y divide-background-200">
        {visibleEpisodes.map((episode) => {
          const isOpen = expanded === episode;
          return (
            <div key={episode} className="bg-background-50">
              <button
                type="button"
                onClick={() => setExpanded(isOpen ? null : episode)}
                className="w-full flex items-center justify-between gap-3 px-4 py-3 text-left hover:bg-background-100 transition-colors cursor-pointer"
              >
                <span className="flex items-center gap-3">
                  <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 text-xs font-semibold">
                    {episode}
                  </span>
                  <span className="text-sm font-medium text-foreground-900">第 {episode} 集</span>
                </span>
                <i
                  className={`text-foreground-400 text-lg transition-transform ${
                    isOpen ? 'ri-subtract-line' : 'ri-add-line'
                  }`}
                ></i>
              </button>
              {isOpen && (
                <div className="px-4 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed pl-11">{buildNote(showTitle, episode)}</p>
                </div>
              )}
            </div>
          );
        })}
      </div>

      {episodeCount > 12 && (
        <div className="flex justify-center mt-4">
          <button
            type="button"
            onClick={() => setShowAll((prev) => !prev)}
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            {showAll ? '收起剧集' : `展开全部 ${episodeCount} 集`}
            <i className={showAll ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'}></i>
          </button>
        </div>
      )}
    </div>
  );
}